import type { Plan } from "@dashboard/entities/plan-funnel";

/**
 * Muestra la cuenta regresiva cuando la membresía activa es Basic en periodo de prueba (`user_membership.trial`).
 * Prime marca `trial = true` en `freeTrialGrowth` (incl. bienvenida 15 días).
 */
export function shouldShowWelcomeBasicTrialCountdown(
  plan: Plan | undefined
): boolean {
  if (!plan) return false;
  if (plan.trial !== true) return false;
  if (plan.is_active === false) return false;

  const name = plan.benefit_plan_name?.toLowerCase();
  if (name !== "basic") return false;

  const days = plan.days_until_prime_expiration;
  return typeof days === "number" && Number.isFinite(days) && days >= 0;
}

export function getWelcomeBasicTrialDaysLeft(plan: Plan): number {
  return Math.max(0, Math.floor(plan.days_until_prime_expiration));
}
